import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MessageText\ReorderMessageTextsController::__invoke
* @see app/Http/Controllers/MessageText/ReorderMessageTextsController.php
* @route '/api/message-text/reorder'
*/
const ReorderMessageTextsController = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderMessageTextsController.url(options),
    method: 'put',
})

ReorderMessageTextsController.definition = {
    methods: ["put"],
    url: '/api/message-text/reorder',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\MessageText\ReorderMessageTextsController::__invoke
* @see app/Http/Controllers/MessageText/ReorderMessageTextsController.php
* @route '/api/message-text/reorder'
*/
ReorderMessageTextsController.url = (options?: RouteQueryOptions) => {
    return ReorderMessageTextsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MessageText\ReorderMessageTextsController::__invoke
* @see app/Http/Controllers/MessageText/ReorderMessageTextsController.php
* @route '/api/message-text/reorder'
*/
ReorderMessageTextsController.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderMessageTextsController.url(options),
    method: 'put',
})

export default ReorderMessageTextsController